// AUTO-GENERATED MLILY catalog from MLILY 2026 Ecommerce Guide. Per-size variant pricing.
export const MLILY_CATALOG = [
 {
  "slug": "mlily-chiropro-firm-13in-hybrid-mattress",
  "name": "MLILY ChiroPro Firm 13\" Hybrid Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 2299,
  "priceFrom": true,
  "firmness": "Firm",
  "height": "13\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 3399
   },
   "Full": {
    "price": 2599
   },
   "King": {
    "price": 3399
   },
   "Queen": {
    "price": 2899
   },
   "Twin": {
    "price": 2299
   },
   "Twin XL": {
    "price": 2299
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+1.0/mlily-chiropro-1-0-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+1.0/mlily-chiropro-1-0-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+1.0/mlily-chiropro-1-0-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+1.0/mlily-chiropro-1-0-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+1.0/mlily-chiropro-1-0-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+1.0/mlily-chiropro-1-0-mattress-angle-04.jpg"
  ],
  "description": "Designed in partnership with the International Chiropractors Association, the ChiroPro underscores our commitment to enhancing sleep through scientifically-backed support. Designed with a focus on optimal body alignment, it incorporates Gel AeroFusion® Memory Foam and a unique three-zone support system that promotes a neutral spine, ensuring your body is properly supported throughout the night, while advanced cooling features regulate temperature.",
  "features": [
   "Chiropractor's Choice",
   "Adapts to Body",
   "3-Zone Pocket Springs",
   "CertiPUR-US & OEKO-TEX Certified",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-chiropro-plush-13in-hybrid-mattress",
  "name": "MLILY ChiroPro Plush 13\" Hybrid Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 2299,
  "priceFrom": true,
  "firmness": "Plush",
  "height": "13\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 3399
   },
   "Full": {
    "price": 2599
   },
   "King": {
    "price": 3399
   },
   "Queen": {
    "price": 2899
   },
   "Twin": {
    "price": 2299
   },
   "Twin XL": {
    "price": 2299
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+3.0/mlily-chiropro-3-0-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+3.0/mlily-chiropro-3-0-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+3.0/mlily-chiropro-3-0-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+3.0/mlily-chiropro-3-0-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+3.0/mlily-chiropro-3-0-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/ChiroPro+3.0/mlily-chiropro-3-0-mattress-angle-04.jpg"
  ],
  "description": "Designed in partnership with the International Chiropractors Association, the ChiroPro underscores our commitment to enhancing sleep through scientifically-backed support. Designed with a focus on optimal body alignment, it incorporates Gel AeroFusion® Memory Foam and a unique three-zone support system that promotes a neutral spine, ensuring your body is properly supported throughout the night, while advanced cooling features regulate temperature.",
  "features": [
   "Chiropractor's Choice",
   "Adapts to Body",
   "3-Zone Pocket Springs",
   "CertiPUR-US & OEKO-TEX Certified",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-midnight-firm-12in-hybrid-mattress",
  "name": "MLILY Midnight Firm 12\" Hybrid Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 2599,
  "priceFrom": true,
  "firmness": "Firm",
  "height": "12\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 3699
   },
   "Full": {
    "price": 2899
   },
   "King": {
    "price": 3699
   },
   "Queen": {
    "price": 3199
   },
   "Twin": {
    "price": 2599
   },
   "Twin XL": {
    "price": 2599
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+1.0/mlily-midnight-1-0-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+1.0/mlily-midnight-1-0-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+1.0/mlily-midnight-1-0-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+1.0/mlily-midnight-1-0-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+1.0/mlily-midnight-1-0-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+1.0/mlily-midnight-1-0-mattress-front-01.jpg"
  ],
  "description": "Midnight delivers a luxury sleep experience, effortlessly delivering opulence and support. The copper-infused memory foam provides a plush yet resilient sleeping surface, designed to cradle your body to relieve pressure and sleep better. The copper-infused AeroFusion® Memory Foam promotes optimal air circulation, while the AdaptiFoam® enhances temperature regulation, delivering a sleep experience that’s as indulgent as it is restorative.",
  "features": [
   "Regulates Temperature",
   "Adapts to Body",
   "Copper Infused",
   "CertiPUR-US & OEKO-TEX Certified",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-midnight-plush-12in-hybrid-mattress",
  "name": "MLILY Midnight Plush 12\" Hybrid Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 2599,
  "priceFrom": true,
  "firmness": "Plush",
  "height": "12\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 3699
   },
   "Full": {
    "price": 2899
   },
   "King": {
    "price": 3699
   },
   "Queen": {
    "price": 3199
   },
   "Twin": {
    "price": 2599
   },
   "Twin XL": {
    "price": 2599
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+3.0/mlily-midnight-3-0-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+3.0/mlily-midnight-3-0-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+3.0/mlily-midnight-3-0-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+3.0/mlily-midnight-3-0-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+3.0/mlily-midnight-3-0-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+3.0/mlily-midnight-3-0-mattress-angle-04.jpg"
  ],
  "description": "Midnight delivers a luxury sleep experience, effortlessly delivering opulence and support. The copper-infused memory foam provides a plush yet resilient sleeping surface, designed to cradle your body to relieve pressure and sleep better. The copper-infused AeroFusion® Memory Foam promotes optimal air circulation, while the AdaptiFoam® enhances temperature regulation, delivering a sleep experience that’s as indulgent as it is restorative.",
  "features": [
   "Regulates Temperature",
   "Adapts to Body",
   "Copper Infused",
   "CertiPUR-US & OEKO-TEX Certified",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-midnight-ice-firm-14in-hybrid-mattress",
  "name": "MLILY Midnight Ice Firm 14\" Hybrid Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 3099,
  "priceFrom": true,
  "firmness": "Firm",
  "height": "14\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 4199
   },
   "King": {
    "price": 4199
   },
   "Queen": {
    "price": 3699
   },
   "Twin XL": {
    "price": 3099
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+1.0/mlily-midnight-ice-1-0-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+1.0/mlily-midnight-ice-1-0-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+1.0/mlily-midnight-ice-1-0-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+1.0/mlily-midnight-ice-1-0-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+1.0/mlily-midnight-ice-1-0-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+1.0/mlily-midnight-ice-1-0-mattress-angle-04.jpg"
  ],
  "description": "Luxury meets cooling comfort in the Midnight ICE mattress. Taking all the benefits of the traditional Midnight mattress, the Midnight ICE adds 2” of plush foam including the copper-infused AeroFusion® Memory Foam with ActiveTemp™ PCM. This mattress offers enhanced cooling and breathability while contouring to your body, creating a sleep environment that’s decadent and rejuvenating.",
  "features": [
   "Regulates Temperature",
   "Adapts to Body",
   "Copper Infused",
   "PCM Coating",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-midnight-ice-plush-14in-hybrid-mattress",
  "name": "MLILY Midnight Ice Plush 14\" Hybrid Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 3099,
  "priceFrom": true,
  "firmness": "Plush",
  "height": "14\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 4199
   },
   "King": {
    "price": 4199
   },
   "Queen": {
    "price": 3699
   },
   "Twin XL": {
    "price": 3099
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+3.0/mlily-midnight-ice-3-0-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+3.0/mlily-midnight-ice-3-0-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+3.0/mlily-midnight-ice-3-0-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+3.0/mlily-midnight-ice-3-0-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+3.0/mlily-midnight-ice-3-0-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/Midnight+ICE+3.0/mlily-midnight-ice-3-0-mattress-angle-04.jpg"
  ],
  "description": "Luxury meets cooling comfort in the Midnight ICE mattress. Taking all the benefits of the traditional Midnight mattress, the Midnight ICE adds 2” of plush foam including the copper-infused AeroFusion® Memory Foam with ActiveTemp™ PCM. This mattress offers enhanced cooling and breathability while contouring to your body, creating a sleep environment that’s decadent and rejuvenating.",
  "features": [
   "Regulates Temperature",
   "Adapts to Body",
   "Copper Infused",
   "PCM Coating",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-wellflex-firm-12in-memory-foam-mattress",
  "name": "MLILY Wellflex Firm 12\" Memory Foam Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 1899,
  "priceFrom": true,
  "firmness": "Firm",
  "height": "12\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 2999
   },
   "Full": {
    "price": 2199
   },
   "King": {
    "price": 2999
   },
   "Queen": {
    "price": 2499
   },
   "Twin": {
    "price": 1899
   },
   "Twin XL": {
    "price": 1899
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+1.0/mlily-wellflex-1-0-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+1.0/mlily-wellflex-1-0-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+1.0/mlily-wellflex-1-0-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+1.0/mlily-wellflex-1-0-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+1.0/mlily-wellflex-1-0-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+1.0/mlily-wellflex-1-0-mattress-angle-04.jpg"
  ],
  "description": "Crafted with precision and a commitment to sustainability, the WellFlex is meticulously engineered for a cool, supportive night’s sleep, featuring a sustainable BioBreeze™ Memory Foam layer that enhances breathability and elevates comfort. Wrapped in a cooling knit fabric cover made from organic, recycled materials, ensures you stay cool while we honor our dedication to creating sustainable, eco-friendly mattresses.",
  "features": [
   "Sustainable Materials",
   "Increased Breathability",
   "Adapts to Body",
   "CertiPUR-US & OEKO-TEX Certified",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-wellflex-plush-12in-memory-foam-mattress",
  "name": "MLILY Wellflex Plush 12\" Memory Foam Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 1899,
  "priceFrom": true,
  "firmness": "Plush",
  "height": "12\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 2999
   },
   "Full": {
    "price": 2199
   },
   "King": {
    "price": 2999
   },
   "Queen": {
    "price": 2499
   },
   "Twin": {
    "price": 1899
   },
   "Twin XL": {
    "price": 1899
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+3.0/mlily-wellflex-3-0-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+3.0/mlily-wellflex-3-0-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+3.0/mlily-wellflex-3-0-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+3.0/mlily-wellflex-3-0-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+3.0/mlily-wellflex-3-0-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+3.0/mlily-wellflex-3-0-mattress-angle-04.jpg"
  ],
  "description": "Crafted with precision and a commitment to sustainability, the WellFlex is meticulously engineered for a cool, supportive night’s sleep, featuring a sustainable BioBreeze™ Memory Foam layer that enhances breathability and elevates comfort. Wrapped in a cooling knit fabric cover made from organic, recycled materials, ensures you stay cool while we honor our dedication to creating sustainable, eco-friendly mattresses.",
  "features": [
   "Sustainable Materials",
   "Increased Breathability",
   "Adapts to Body",
   "CertiPUR-US & OEKO-TEX Certified",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-wellflex-ice-firm-14in-memory-foam-mattress",
  "name": "MLILY Wellflex Ice Firm 14\" Memory Foam Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 2399,
  "priceFrom": true,
  "firmness": "Firm",
  "height": "14\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 3499
   },
   "King": {
    "price": 3499
   },
   "Queen": {
    "price": 2999
   },
   "Twin XL": {
    "price": 2399
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+1.0/mlily-wellflex-ice-1-0-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+1.0/mlily-wellflex-ice-1-0-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+1.0/mlily-wellflex-ice-1-0-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+1.0/mlily-wellflex-ice-1-0-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+1.0/mlily-wellflex-ice-1-0-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+1.0/mlily-wellflex-ice-1-0-mattress-angle-04.jpg"
  ],
  "description": "The WellFlex ICE combines the gel-infused memory foam layers from the traditional WellFlex, but adds an additional 2” of foam including our Gel AeroFusion® Memory Foam with ActiveTemp™ PCM for even more enhanced cooling. Combined with our cooling fabric cover made from organic and recycled materials, the WellFlex ICE keeps you cool and comfortable while focusing on sustainability.",
  "features": [
   "Sustainable Materials",
   "Increased Breathability",
   "Adapts to Body",
   "PCM Coating",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-wellflex-ice-plush-14in-memory-foam-mattress",
  "name": "MLILY Wellflex Ice Plush 14\" Memory Foam Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 2399,
  "priceFrom": true,
  "firmness": "Plush",
  "height": "14\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 3499
   },
   "King": {
    "price": 3499
   },
   "Queen": {
    "price": 2999
   },
   "Twin XL": {
    "price": 2399
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+3.0/mlily-wellflex-ice-3-0-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+3.0/mlily-wellflex-ice-3-0-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+3.0/mlily-wellflex-ice-3-0-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+3.0/mlily-wellflex-ice-3-0-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+3.0/mlily-wellflex-ice-3-0-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/WellFlex+ICE+3.0/mlily-wellflex-ice-3-0-mattress-angle-04.jpg"
  ],
  "description": "The WellFlex ICE combines the gel-infused memory foam layers from the traditional WellFlex, but adds an additional 2” of foam including our Gel AeroFusion® Memory Foam with ActiveTemp™ PCM for even more enhanced cooling. Combined with our cooling fabric cover made from organic and recycled materials, the WellFlex ICE keeps you cool and comfortable while focusing on sustainability.",
  "features": [
   "Sustainable Materials",
   "Increased Breathability",
   "Adapts to Body",
   "PCM Coating",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-mufc-dream-medium-12in-memory-foam-mattress",
  "name": "MLILY MUFC Dream Medium 12\" Memory Foam Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 599,
  "priceFrom": true,
  "firmness": "Medium",
  "height": "12\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 1199
   },
   "Full": {
    "price": 899
   },
   "King": {
    "price": 1199
   },
   "Queen": {
    "price": 999
   },
   "Twin": {
    "price": 599
   },
   "Twin XL": {
    "price": 699
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/The+Dream/mlily-the-dream-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/The+Dream/mlily-the-dream-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/The+Dream/mlily-the-dream-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/The+Dream/mlily-the-dream-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/The+Dream/mlily-the-dream-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/The+Dream/mlily-the-dream-mattress-angle-04.jpg"
  ],
  "description": "This mattress is the result of MLILY's global partnership with Manchester United Football Club. It is an upgrade from the previous Dream mattress, also known as the Theatre of Dreams. This mattress is now an all-foam build to allow for a medium feel designed to adapt to the body's natural curves. Its Gel AeroFusion™ Memory Foam and Adaptive Foam layers allow for air circulation and extended coolness to ensure a more relaxed night's sleep.",
  "features": [
   "Athlete-Inspired Recovery",
   "Increased Breathability",
   "Advanced Cooling",
   "High-Performance\nTencel® Fabric",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-powercool-firm-11-5in-hybrid-mattress",
  "name": "MLILY PowerCool Firm 11.5\" Hybrid Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 2599,
  "priceFrom": true,
  "firmness": "Firm",
  "height": "11.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 3799
   },
   "King": {
    "price": 3799
   },
   "Queen": {
    "price": 3199
   },
   "Twin XL": {
    "price": 2599
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Firm/mlily-powercool-firm-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Firm/mlily-powercool-firm-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Firm/mlily-powercool-firm-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Firm/mlily-powercool-firm-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Firm/mlily-powercool-firm-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Firm/mlily-powercool-firm-mattress-angle-04.jpg"
  ],
  "description": "Engineered with advanced foam layering, PowerCool enhances breathability while delivering responsive, balanced support. Choose the feel that fits you best with two comfort options: Firm for a more supportive, stable surface or Medium for adaptive contouring with a slightly softer touch.",
  "features": [
   "Regulates Temperature",
   "Adapts to Body",
   "Advanced Cooling",
   "CertiPUR-US & OEKO-TEX Certified",
   "10-year Warranty"
  ]
 },
 {
  "slug": "mlily-powercool-medium-11-5in-hybrid-mattress",
  "name": "MLILY PowerCool Medium 11.5\" Hybrid Mattress",
  "brand": "mlily",
  "category": "mattresses",
  "price": 2599,
  "priceFrom": true,
  "firmness": "Medium",
  "height": "11.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "California King": {
    "price": 3799
   },
   "King": {
    "price": 3799
   },
   "Queen": {
    "price": 3199
   },
   "Twin XL": {
    "price": 2599
   }
  },
  "image": "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Medium/mlily-powercool-medium-mattress-hero-01.jpg",
  "gallery": [
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Medium/mlily-powercool-medium-mattress-hero-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Medium/mlily-powercool-medium-mattress-angle-01.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Medium/mlily-powercool-medium-mattress-angle-02.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Medium/mlily-powercool-medium-mattress-angle-03.jpg",
   "https://mlilyusa-media.s3.us-east-1.amazonaws.com/Design/ecommerce-images/PowerCool+Medium/mlily-powercool-medium-mattress-angle-04.jpg"
  ],
  "description": "Engineered with advanced foam layering, PowerCool enhances breathability while delivering responsive, balanced support. Choose the feel that fits you best with two comfort options: Firm for a more supportive, stable surface or Medium for adaptive contouring with a slightly softer touch.",
  "features": [
   "Regulates Temperature",
   "Adapts to Body",
   "Advanced Cooling",
   "CertiPUR-US & OEKO-TEX Certified",
   "10-year Warranty"
  ]
 }
];
